import createStore from "astrid-helpers/src/createStore";

export const [getSelectedClipId, setSelectedClipId, useSelectedClipId] = createStore();
